import {
  profit_breakdown_area_v4,
  profit_breakdown_cluster_v4,
  profit_breakdown_overall_v4,
  profit_breakdown_branch_v4,
} from "../../v4-services/reports/profit_breakdown_service";
import { actionTypes } from "../action_types";

const defaultData = {};

const createProfitBreakdownAction = (fetchFunction, actionType) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionType,
        payload: resp.data !== null ? resp.data : defaultData,
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetProfitBreakdownOverall_v4 = createProfitBreakdownAction(
  profit_breakdown_overall_v4,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_GET_OVERALL
);

export const GetProfitBreakdownCluster_v4 = createProfitBreakdownAction(
  profit_breakdown_cluster_v4,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_GET_CLUSTER
);

export const GetProfitBreakdownArea_v4 = createProfitBreakdownAction(
  profit_breakdown_area_v4,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_TARGET_GET_AREA
);

export const GetProfitBreakdownBranch_v4 = createProfitBreakdownAction(
  profit_breakdown_branch_v4,
  actionTypes.REPORTS_PROFIT_BREAKDOWN_TARGET_GET_BRANCH
);
